module.exports = __webpack_public_path__ + "img/close.2158c69b.png";